/* eslint-disable no-undef */
(function () {
  'use strict';

  window.OletLens = window.OletLens || {};

  var Config = window.OletLens.Config || {};
  var Utils = window.OletLens.Utils || {};
  var StepsModule = window.OletLens.StepsModule || {};

  var VariantPriceMap = {};
  try {
    var priceScript = document.getElementById('lens-variant-prices-json');
    if (priceScript) {
      var rawJson = priceScript.textContent || priceScript.innerText || '{}';
      try {
        if (typeof console !== 'undefined') {
          console.log('[LensPricing] Raw JSON snippet:', rawJson.substring(0, 400));
        }
      } catch (e0) {}
      VariantPriceMap = JSON.parse(rawJson);
    }
  } catch (e) {
    try {
      if (typeof console !== 'undefined') {
        console.error('[LensPricing] Failed to parse VariantPriceMap JSON:', e && e.message ? e.message : e);
      }
    } catch (e1) {}
    VariantPriceMap = {};
  }
  try {
    if (typeof console !== 'undefined') {
      console.log('[LensPricing] Loaded VariantPriceMap keys:', Object.keys(VariantPriceMap || {}).length);
    }
  } catch (e2) {}

  var FrameVariantPriceMap = {};
  try {
    var framePriceScript = document.getElementById('frame-variant-prices-json');
    if (framePriceScript) {
      FrameVariantPriceMap = JSON.parse(framePriceScript.textContent || framePriceScript.innerText || '{}');
    }
  } catch (e3) {
    FrameVariantPriceMap = {};
  }

  function centsToAmount(cents) {
    var n = Number(cents);
    return isNaN(n) ? 0 : n / 100;
  }

  function getSelectedFrameVariantId() {
    var input = document.querySelector('input[name="id"].product-variant-id');
    if (input && input.value) return Number(input.value) || null;
    var variantParam = new URLSearchParams(window.location.search).get('variant');
    return variantParam ? Number(variantParam) || null : null;
  }

  function getFrameBasePrice(productPriceEl, variantId) {
    var resolvedVariantId = variantId != null ? variantId : getSelectedFrameVariantId();
    if (resolvedVariantId != null && FrameVariantPriceMap[String(resolvedVariantId)] != null) {
      return centsToAmount(FrameVariantPriceMap[String(resolvedVariantId)]);
    }
    if (!productPriceEl) return 0;
    var cents = productPriceEl.getAttribute('product-price-cents');
    if (cents != null && cents !== '') {
      return centsToAmount(cents);
    }
    return 0;
  }

  function getVariantPrice(variantId) {
    if (!variantId) return null;
    var cents = VariantPriceMap[String(variantId)];
    if (typeof cents === 'number') {
      var val = cents / 100;
      try {
        if (typeof console !== 'undefined') {
          console.log('[LensPricing] Price for variant', String(variantId), '→ cents:', cents, 'value:', val);
        }
      } catch (e3) {}
      return val;
    }
    try {
      if (typeof console !== 'undefined') {
        console.warn('[LensPricing] No price found for variant', String(variantId));
      }
    } catch (e4) {}
    return null;
  }

  function normalizeSunglassesType(type) {
    if (type === 'photochromic_polarized_sunglasses') return 'photochromic_polarized';
    return type;
  }

  function showToast(message, type) {
    if (window.Toastify) {
      window
        .Toastify({
          text: message,
          duration: 3000,
          close: true,
          gravity: 'top',
          position: 'right',
          style: {
            backgroundColor: type === 'error' ? '#dc2626' : '#009AD6',
          },
        })
        .showToast();
    } else {
      alert(message);
    }
  }

  function createPubSub() {
    var listeners = [];
    return {
      subscribe: function (fn) {
        if (typeof fn === 'function') listeners.push(fn);
      },
      publish: function (state) {
        listeners.forEach(function (fn) {
          try {
            fn(state);
          } catch (e) {
            /* ignore */
          }
        });
      },
    };
  }

  /**
   * Refresh lens-step disclaimers using live Config (avoids stale closure) and ensure nodes exist.
   */
  function syncLensTypeStepNotes(usage) {
    usage = usage || '';
    var cfg = window.OletLens && window.OletLens.Config ? window.OletLens.Config : {};

    var readingNoteEl = document.getElementById('reading-note');
    if (!readingNoteEl && usage === 'reading') {
      var step4 = document.getElementById('step-4');
      var lensSelection = document.getElementById('lens-selection');
      if (step4 && lensSelection) {
        readingNoteEl = document.createElement('p');
        readingNoteEl.id = 'reading-note';
        readingNoteEl.className = 'text-[14px] text-gray-600 font-normal mb-[12px] px-[12px]';
        step4.insertBefore(readingNoteEl, lensSelection);
      }
    }

    var noteEl = document.getElementById('polycarbonate-note');
    if (noteEl) {
      var hideForPoly = ['progressives', 'bifocals', 'reading'];
      var polyNote = cfg.POLYCARBONATE_NOTE || '';
      noteEl.textContent = polyNote;
      noteEl.style.display =
        hideForPoly.indexOf(usage) !== -1 || !polyNote ? 'none' : 'block';
    }

    var progNoteEl = document.getElementById('progressives-package-note');
    if (progNoteEl) {
      var progText = cfg.PROGRESSIVES_PACKAGE_NOTE || '';
      progNoteEl.textContent = progText;
      progNoteEl.style.display = usage === 'progressives' && progText ? 'block' : 'none';
    }

    var bifNoteEl = document.getElementById('bifocals-note');
    if (bifNoteEl) {
      var bifNote = cfg.BIFOCALS_NOTE || '';
      bifNoteEl.textContent = bifNote;
      bifNoteEl.style.display = usage === 'bifocals' && bifNote ? 'block' : 'none';
    }

    readingNoteEl = document.getElementById('reading-note');
    if (readingNoteEl) {
      var readingNote = cfg.READING_NOTE || '';
      readingNoteEl.textContent = readingNote;
      readingNoteEl.style.display = usage === 'reading' && readingNote ? 'block' : 'none';
    }
  }

  function createInitialState() {
    return {
      usage: null,
      prescriptionType: null,
      lensType: null,
      lensVariantId: null,
      lensTypePrice: 0,
      sunglasses: null,
      sunglassesColor: null,
      sunglassesPrice: 0,
      addons: [],
      prescription: null,
      reading: null,
      rxMethod: 'manual',
      rxFileUrl: null,
      rxFilePreview: null,
      editBundleKey: null,
    };
  }

  function LensSelectorApp() {
    this.state = createInitialState();
    this.currentStep = Config.STEPS ? Config.STEPS.USAGE : 1;
    this.totalSteps = Config.STEPS ? Config.STEPS.SUMMARY : 7;
    this.pubsub = createPubSub();

    this.elements = {
      nextButton: document.getElementById('next-step'),
      prevButton: document.getElementById('prev-step'),
      saveButton: document.getElementById('save-lens-data'),
      priceElement: document.getElementById('updated-price'),
      productPrice: document.getElementById('product-price'),
      lensContainer: document.getElementById('lens-selection'),
      loadPreviousOrderBtn: document.getElementById('load-previous-order'),
    };

    this.basePrice = getFrameBasePrice(this.elements.productPrice);

    this.selectedData = this.state;
  }

  LensSelectorApp.prototype.setState = function (key, value) {
    this.state[key] = value;
    this.selectedData = this.state;
    this.pubsub.publish(this.state);
  };

  LensSelectorApp.prototype.onStateChange = function (fn) {
    this.pubsub.subscribe(fn);
  };

  /* ─── NAVIGATION ─── */

  LensSelectorApp.prototype.getNextStep = function () {
    var S = Config.STEPS;
    var usage = this.state.usage;
    var step = this.currentStep;

    if (step === S.USAGE) {
      if (usage === 'prescription') return S.PRESCRIPTION_TYPE;
      if (usage === 'single_vision' || usage === 'progressives' || usage === 'bifocals') return S.PRESCRIPTION_TYPE;
      if (usage === 'reading') return S.READING_TYPE;
      if (usage === 'non-prescription') return S.LENS_TYPE;
    }

    if (step === S.PRESCRIPTION_TYPE) {
      return S.PRESCRIPTION;
    }

    if (step === S.READING_TYPE) {
      return S.LENS_TYPE;
    }

    if (step === S.PRESCRIPTION) {
      return S.LENS_TYPE;
    }

    if (step === S.LENS_TYPE) {
      if (this.state.lensType === 'polycarbonate') return S.ADDON;
      return S.SUNGLASSES;
    }

    if (step === S.SUNGLASSES) {
      return S.ADDON;
    }

    if (step === S.ADDON) {
      return S.SUMMARY;
    }

    return step;
  };

  LensSelectorApp.prototype.getPrevStep = function () {
    var S = Config.STEPS;
    var usage = this.state.usage;
    var step = this.currentStep;

    if (step === S.SUMMARY) return S.ADDON;
    if (step === S.ADDON) {
      if (this.state.lensType === 'polycarbonate') return S.LENS_TYPE;
      return S.SUNGLASSES;
    }
    if (step === S.SUNGLASSES) return S.LENS_TYPE;
    if (step === S.LENS_TYPE) {
      if (usage === 'reading') return S.READING_TYPE;
      if (usage === 'non-prescription') return S.USAGE;
      return S.PRESCRIPTION;
    }
    if (step === S.PRESCRIPTION) return S.PRESCRIPTION_TYPE;
    if (step === S.PRESCRIPTION_TYPE) return S.USAGE;
    if (step === S.READING_TYPE) return S.USAGE;

    return S.USAGE;
  };

  LensSelectorApp.prototype.validateCurrentStep = function () {
    var S = Config.STEPS;
    var step = this.currentStep;

    if (step === S.USAGE && !this.state.usage) {
      return 'Please select a usage type.';
    }

    if (step === S.PRESCRIPTION_TYPE) {
      var u = this.state.usage;
      if (u !== 'single_vision' && u !== 'progressives' && u !== 'bifocals') {
        return 'Please select a prescription type (Single Vision, Progressives, or Bifocals).';
      }
    }

    if (step === S.READING_TYPE) {
      var ReadingModule = window.OletLens.ReadingModule;
      if (ReadingModule && typeof ReadingModule.validate === 'function') {
        var rResult = ReadingModule.validate();
        if (!rResult.valid) return rResult.errors.join(', ');
      }
    }

    if (step === S.PRESCRIPTION) {
      var PrescriptionModule = window.OletLens.PrescriptionModule;
      if (PrescriptionModule && typeof PrescriptionModule.validate === 'function') {
        var pResult = PrescriptionModule.validate(this.state);
        if (!pResult.valid) return pResult.errors.join(', ');
      }
    }

    if (step === S.LENS_TYPE && !this.state.lensType) {
      return 'Please select a lens type.';
    }

    if (step === S.SUNGLASSES) {
      var SunglassesModule = window.OletLens.SunglassesModule;
      if (SunglassesModule && typeof SunglassesModule.validate === 'function') {
        var sResult = SunglassesModule.validate();
        if (!sResult.valid) return sResult.errors.join(', ');
      }
    }

    return null;
  };

  LensSelectorApp.prototype.navigateNext = function () {
    var error = this.validateCurrentStep();
    if (error) {
      showToast(error);
      return;
    }

    if (this.currentStep === Config.STEPS.PRESCRIPTION) {
      this.collectPrescriptionData();
      this.syncRxMethodWithPrescriptionUi();
    }
    if (this.currentStep === Config.STEPS.READING_TYPE) {
      this.collectReadingData();
    }

    var next = this.getNextStep();
    this.currentStep = next;

    if (next === Config.STEPS.LENS_TYPE) {
      this.renderLensOptions();
    }
    if (next === Config.STEPS.SUNGLASSES) {
      this.updateSunglassesVisibility();
    }
    if (next === Config.STEPS.SUMMARY) {
      this.renderSummary();
    }

    this.renderStep();
    this.calculateTotalPrice();
  };

  LensSelectorApp.prototype.navigatePrev = function () {
    var S = Config.STEPS;

    if (this.currentStep === S.PRESCRIPTION_TYPE) {
      this.setState('usage', 'prescription');
    }

    var prev = this.getPrevStep();
    this.currentStep = prev;

    if (prev === S.LENS_TYPE) {
      this.renderLensOptions();
    }

    this.renderStep();
    this.calculateTotalPrice();
  };

  LensSelectorApp.prototype.renderStep = function () {
    if (StepsModule.showStep) StepsModule.showStep(this.currentStep);
    if (StepsModule.updateTitle) StepsModule.updateTitle(this.currentStep, { usage: this.state.usage });
    if (StepsModule.updateButtons) StepsModule.updateButtons(this.currentStep, this.totalSteps);
    if (this.currentStep === Config.STEPS.LENS_TYPE) {
      syncLensTypeStepNotes(this.state.usage);
    }
    this.syncUIForCurrentStep();
  };

  LensSelectorApp.prototype.syncUIForCurrentStep = function () {
    var S = Config.STEPS;
    var step = this.currentStep;
    var usage = this.state.usage;

    if (step === S.USAGE) {
      if (!usage) return;
      var mainUsageEls = document.querySelectorAll('#main-options .lens-usage');
      mainUsageEls.forEach(function (el) {
        el.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      });

      var isPrescriptionSub = usage === 'single_vision' || usage === 'progressives' || usage === 'bifocals';
      var targetUsage = isPrescriptionSub ? 'prescription' : usage;
      var usageCard = document.querySelector('#main-options .lens-usage[usage-type="' + targetUsage + '"]');
      if (usageCard) {
        usageCard.classList.add('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      }
      return;
    }

    if (step === S.PRESCRIPTION_TYPE) {
      if (!usage) return;
      var typeEls = document.querySelectorAll('#prescription-type-selection .lens-usage');
      typeEls.forEach(function (el) {
        el.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
        if (el.getAttribute('usage-type') === usage) {
          el.classList.add('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
        }
      });
      return;
    }

    if (step === S.READING_TYPE) {
      var reading = this.state.reading || {};
      var readingStrength = reading.strength || reading.reading_strength;
      var ReadingModule = window.OletLens.ReadingModule;
      if (readingStrength && ReadingModule && ReadingModule.handleMagnificationSelection) {
        ReadingModule.handleMagnificationSelection(String(readingStrength));
      }
      return;
    }

    if (step === S.LENS_TYPE) {
      var lensType = this.state.lensType;
      if (!lensType) return;
      var lensCards = document.querySelectorAll('#lens-selection .lens-type');
      lensCards.forEach(function (card) {
        card.classList.remove('active-lens', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      });
      var selected = document.querySelector('#lens-selection .lens-type[lens-type="' + lensType + '"]');
      if (selected) {
        selected.classList.add('active-lens', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      }
      return;
    }

    if (step === S.SUNGLASSES) {
      var sunType = this.state.sunglasses;
      var sunColor = this.state.sunglassesColor;
      if (!sunType) return;
      var sunEls = document.querySelectorAll('.sunglasses-upgrade');
      sunEls.forEach(function (el) {
        el.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
      });
      var sunEl = document.querySelector('.sunglasses-upgrade[sunglasses-type="' + sunType + '"]');
      if (sunEl) {
        sunEl.classList.add('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
        if (sunColor) {
          var colorEls = sunEl.querySelectorAll('.color-select');
          colorEls.forEach(function (c) {
            c.classList.remove('selected-color');
          });
          var colorEl = sunEl.querySelector('.color-select[data-color="' + sunColor + '"]');
          if (colorEl) colorEl.classList.add('selected-color');
        }
      }
      return;
    }

    if (step === S.ADDON) {
      var addons = this.state.addons || [];
      if (window.OletLens.AddonsModule && typeof window.OletLens.AddonsModule.syncDomToAddons === 'function') {
        window.OletLens.AddonsModule.syncDomToAddons(addons);
      } else {
        var addonEls = document.querySelectorAll('.lens-addon');
        addonEls.forEach(function (el) {
          el.classList.remove('active', '!border-[#009AD6]', '!bg-[#E6F7FF]');
        });
        addons.forEach(function (key) {
          var addonEl = document.querySelector('.lens-addon[lens-addon="' + key + '"]');
          if (addonEl) {
            addonEl.classList.add('active', '!border-[#009AD6]', '!bg-[#E6F7FF]');
          }
        });
      }
      return;
    }

    if (step === S.SUMMARY) {
      this.renderSummary();
    }
  };

  /* ─── USAGE SELECTION (step-1) ─── */

  LensSelectorApp.prototype.initUsageHandlers = function () {
    var self = this;
    var mainOptions = document.getElementById('main-options');
    var prescriptionOptions = document.getElementById('prescription-options');

    if (prescriptionOptions) {
      prescriptionOptions.classList.add('hidden');
      prescriptionOptions.style.display = 'none';
    }

    if (!mainOptions) return;

    var mainUsageEls = mainOptions.querySelectorAll('.lens-usage');

    mainUsageEls.forEach(function (el) {
      el.addEventListener('click', function () {
        var usageType = el.getAttribute('usage-type');

        mainUsageEls.forEach(function (item) {
          item.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
        });
        el.classList.add('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');

        self.setState('usage', usageType);
        self.setState('lensType', null);
        self.setState('lensTypePrice', 0);
        self.setState('lensVariantId', null);
        self.stripIncompatibleLensAddons();
        self.calculateTotalPrice();
      });
    });

    this.initPrescriptionTypeHandlers();
  };

  /* ─── PRESCRIPTION TYPE SELECTION (step-2) ─── */

  LensSelectorApp.prototype.initPrescriptionTypeHandlers = function () {
    var self = this;
    var container = document.getElementById('prescription-type-selection');
    if (!container) return;

    var typeEls = container.querySelectorAll('.lens-usage');

    typeEls.forEach(function (el) {
      el.addEventListener('click', function () {
        var usageType = el.getAttribute('usage-type');

        typeEls.forEach(function (item) {
          item.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
        });
        el.classList.add('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');

        self.setState('usage', usageType);
        self.setState('lensType', null);
        self.setState('lensTypePrice', 0);
        self.setState('lensVariantId', null);

        self.stripIncompatibleLensAddons();
        self.calculateTotalPrice();

        self.updateAddValuesVisibility(usageType);

        document.dispatchEvent(
          new CustomEvent('lens-type-changed', {
            detail: { usageType: usageType },
          }),
        );
      });
    });
  };

  /* ─── ADD values visibility ─── */

  LensSelectorApp.prototype.updateAddValuesVisibility = function (usageType) {
    if (typeof window.updateAddValuesVisibility === 'function') {
      window.updateAddValuesVisibility(usageType);
    }
  };

  /** Keep rxMethod aligned with visible upload-vs-manual UI and any attached prescription file. */
  LensSelectorApp.prototype.syncRxMethodWithPrescriptionUi = function () {
    var hasLocalUpload = !!this.uploadedPrescriptionFileBase64;
    var hasRemoteUrl = !!(this.state.rxFileUrl && String(this.state.rxFileUrl).trim());
    if (hasLocalUpload || hasRemoteUrl) {
      if (this.state.rxMethod !== 'upload') {
        this.setState('rxMethod', 'upload');
      }
      return;
    }

    var form = document.getElementById('prescription-form-container');
    var upload = document.getElementById('prescription-image-upload-container');
    if (!form || !upload) return;

    var manualHidden = form.classList.contains('hide-prescription');
    var uploadHidden = upload.classList.contains('hide-prescription');

    if (manualHidden && !uploadHidden) {
      this.setState('rxMethod', 'upload');
    } else if (!manualHidden && uploadHidden) {
      this.setState('rxMethod', 'manual');
    }
  };

  LensSelectorApp.prototype.isPrescriptionUploadFlow = function () {
    if (this.state.rxMethod === 'upload') return true;
    if (this.uploadedPrescriptionFileBase64) return true;
    if (this.state.rxFileUrl && String(this.state.rxFileUrl).trim()) return true;
    return false;
  };

  /* ─── LENS OPTIONS RENDERING (step-4) ─── */

  LensSelectorApp.prototype.renderLensOptions = function () {
    var container = this.elements.lensContainer;
    if (!container) {
      container = document.getElementById('lens-selection');
      this.elements.lensContainer = container;
    }
    if (!container) return;

    container.innerHTML = '';

    var usage = this.state.usage;
    var optionsData = Config.LENS_OPTIONS_DATA || {};
    var options = optionsData[usage];
    if (!options || !options.length) {
      syncLensTypeStepNotes(usage);
      return;
    }

    var recommended = null;
    if (usage !== 'non-prescription' && usage !== 'reading' && !this.isPrescriptionUploadFlow()) {
      if (this.state.prescription && this.state.prescription.od && this.state.prescription.os) {
        var rx = this.state.prescription;
        recommended = Utils.getRecommendedLensTier(rx.od.sph || 0, rx.od.cyl || 0, rx.os.sph || 0, rx.os.cyl || 0);
      } else {
        recommended = 'basic';
      }
    }

    var self = this;
    var Currency = window.OletLens && window.OletLens.Currency;

    options.forEach(function (opt, idx) {
      var div = document.createElement('div');
      div.setAttribute('lens-type', opt.type);
      div.className =
        'bg-[#C7C7C71A] p-[16px] xl:p-[18px] rounded-[8px] step border-2 border-gray-200 cursor-pointer lens-type';

      var isRec = recommended && opt.type === recommended;
      var recBadge = isRec
        ? '<span class="recommended-badge ml-[8px] text-[12px] bg-[#009AD6] text-white px-[8px] py-[2px] rounded-full">Recommended</span>'
        : '<span class="recommended-badge hidden"></span>';

      var lensVariants = Config.LENS_BASE_VARIANTS && Config.LENS_BASE_VARIANTS[usage];
      var lensVariantId = lensVariants && lensVariants[opt.type];
      var variantPrice = getVariantPrice(lensVariantId);
      var displayPrice = variantPrice != null ? variantPrice : opt.price;

      var priceText =
        displayPrice > 0
          ? Currency && typeof Currency.formatMoney === 'function'
            ? Currency.formatMoney(displayPrice)
            : '$' + displayPrice.toFixed(2)
          : 'Free';
      var indexText = opt.index ? ' (Index ' + opt.index + ')' : '';

      div.innerHTML =
        '<div class="grid grid-cols-12 items-start gap-4">' +
        '<div class="col-span-12 sm:col-span-1 flex items-center w-full gap-4">' +
        '<div class="w-[28px] h-[28px] bg-[#009AD6] rounded-full text-white flex justify-center items-center font-bold">' +
        (idx + 1) +
        '</div>' +
        '<h3 class="text-[#009AD6] flex items-center gap-2 text-[18px] font-bold block sm:hidden">' +
        '<span>' +
        opt.name +
        '</span>' +
        recBadge +
        '</h3>' +
        '</div>' +
        '<div class="col-span-12 sm:col-span-11 flex flex-col gap-2">' +
        '<div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">' +
        '<h3 class="text-[#009AD6] flex items-center gap-2 text-[18px] font-bold hidden sm:flex">' +
        '<span>' +
        opt.name +
        '</span>' +
        recBadge +
        '</h3>' +
        '<p class="lense-type-price text-[16px] sm:text-[18px] font-bold whitespace-nowrap">' +
        priceText +
        '</p>' +
        '</div>' +
        '<p class="text-[14px] text-black font-normal">' +
        opt.description +
        '</p>' +
        '</div>' +
        '</div>';

      div.addEventListener('click', function () {
        self.handleLensTypeSelection(div, opt);
      });

      container.appendChild(div);
    });

    // Only auto-select recommendation when user has not selected any lens yet.
    var shouldSelectRecommended = recommended && !this.state.lensType;
    if (shouldSelectRecommended) {
      var recOpt = null;
      for (var i = 0; i < options.length; i++) {
        if (options[i].type === recommended) {
          recOpt = options[i];
          break;
        }
      }
      if (recOpt) {
        var recCard = container.querySelector('.lens-type[lens-type="' + recommended + '"]');
        if (recCard) {
          self.handleLensTypeSelection(recCard, recOpt);
        }
      }
    }

    syncLensTypeStepNotes(usage);
  };

  LensSelectorApp.prototype.handleLensTypeSelection = function (element, opt) {
    var all = document.querySelectorAll('.lens-type');
    all.forEach(function (el) {
      el.classList.remove('active-lens', 'border-[#009AD6]', 'bg-[#E6F7FF]');
    });
    element.classList.add('active-lens', 'border-[#009AD6]', 'bg-[#E6F7FF]');

    this.setState('lensType', opt.type);
    var usage = this.state.usage;
    var lensVariants = Config.LENS_BASE_VARIANTS && Config.LENS_BASE_VARIANTS[usage];
    var lensVariantId = lensVariants && lensVariants[opt.type];
    this.setState('lensVariantId', lensVariantId || null);
    var variantPrice = getVariantPrice(lensVariantId);
    this.setState('lensTypePrice', variantPrice != null ? variantPrice : opt.price || 0);

    var eliteEl = document.querySelector(
      '[sunglasses-type="photochromic_polarized"], [sunglasses-type="photochromic_polarized_sunglasses"], [sunglasses-type="night_driving"]',
    );
    if (eliteEl) {
      eliteEl.style.display = opt.type === 'elite' ? 'none' : '';
    }

    this.stripIncompatibleLensAddons();

    this.calculateTotalPrice();
  };

  /**
   * Remove add-ons and sunglasses selections incompatible with current usage / lens type / base variant.
   */
  LensSelectorApp.prototype.stripIncompatibleLensAddons = function () {
    var usage = this.state.usage || 'single_vision';
    var tier = this.state.lensType;
    var vid = this.state.lensVariantId != null ? Number(this.state.lensVariantId) : null;
    var disallowed =
      typeof Utils.getDisallowedAddonKeys === 'function' ? Utils.getDisallowedAddonKeys(usage, tier, vid) : [];
    if (!disallowed.length) return;

    var ad = this.state.addons || [];
    var filtered = ad.filter(function (k) {
      var nk = Utils.normalizeSunglassesAddonKey ? Utils.normalizeSunglassesAddonKey(k) : k;
      return disallowed.indexOf(nk) === -1;
    });
    if (filtered.length !== ad.length) {
      this.setState('addons', filtered);
    }

    disallowed.forEach(function (key) {
      var addonEl = document.querySelector('.lens-addon[lens-addon="' + key + '"]');
      if (addonEl) addonEl.classList.remove('active', '!border-[#009AD6]', '!bg-[#E6F7FF]');
    });

    var sunNorm = this.state.sunglasses
      ? Utils.normalizeSunglassesAddonKey
        ? Utils.normalizeSunglassesAddonKey(this.state.sunglasses)
        : this.state.sunglasses
      : null;
    if (sunNorm && disallowed.indexOf(sunNorm) !== -1) {
      var SunglassesModule = window.OletLens.SunglassesModule;
      if (SunglassesModule && typeof SunglassesModule.clearSelection === 'function') {
        SunglassesModule.clearSelection(this, { skipCalculate: true });
      } else {
        this.setState('sunglasses', null);
        this.setState('sunglassesColor', null);
        this.setState('sunglassesPrice', 0);
      }
    }
  };

  /* ─── SUNGLASSES VISIBILITY ─── */

  LensSelectorApp.prototype.updateSunglassesVisibility = function () {
    var SunglassesModule = window.OletLens.SunglassesModule;
    if (SunglassesModule && typeof SunglassesModule.updateOptions === 'function') {
      SunglassesModule.updateOptions(this.state.usage);
    }
  };

  /* ─── COLLECT FORM DATA ─── */

  LensSelectorApp.prototype.collectPrescriptionData = function () {
    var PrescriptionModule = window.OletLens.PrescriptionModule;
    if (PrescriptionModule && typeof PrescriptionModule.getFormData === 'function') {
      var data = PrescriptionModule.getFormData();
      this.setState('prescription', data);
    }
  };

  LensSelectorApp.prototype.collectReadingData = function () {
    var ReadingModule = window.OletLens.ReadingModule;
    if (ReadingModule && typeof ReadingModule.getFormData === 'function') {
      var data = ReadingModule.getFormData();
      this.setState('reading', data);
    }
  };

  /* ─── PRICE CALCULATION ─── */

  LensSelectorApp.prototype.calculateTotalPrice = function () {
    var Currency = window.OletLens && window.OletLens.Currency;

    var total = this.basePrice || 0;

    total += this.state.lensTypePrice || 0;
    total += this.state.sunglassesPrice || 0;

    var addons = this.state.addons || [];
    addons.forEach(function (addonKey) {
      var addonVariantId = Config.ADDON_VARIANTS && Config.ADDON_VARIANTS[addonKey];
      var addonPrice = getVariantPrice(addonVariantId);
      if (addonPrice != null) {
        total += addonPrice;
      }
    });

    var prismCheckbox = document.getElementById('prism');
    if (prismCheckbox && prismCheckbox.checked) {
      total += 9;
    }

    if (this.elements.priceElement) {
      if (Currency && typeof Currency.formatMoney === 'function') {
        this.elements.priceElement.textContent = Currency.formatMoney(total);
      } else {
        this.elements.priceElement.textContent = '$' + total.toFixed(2) + ' USD';
      }
    }

    return total;
  };

  /* ─── SUMMARY ─── */

  LensSelectorApp.prototype.renderSummary = function () {
    var SummaryModule = window.OletLens.SummaryModule;
    if (SummaryModule && typeof SummaryModule.render === 'function') {
      SummaryModule.render(this.state, Config);
    }

    this.updateSummaryPrices();
  };

  LensSelectorApp.prototype.updateSummaryPrices = function () {
    var Currency = window.OletLens && window.OletLens.Currency;
    var fmt =
      Currency && typeof Currency.formatMoney === 'function'
        ? Currency.formatMoney.bind(Currency)
        : function (p) {
            return '$' + p.toFixed(2);
          };

    var lensTypePrice = this.state.lensTypePrice || 0;
    var el = document.getElementById('summary-lens-type-price');
    if (el) {
      el.textContent = lensTypePrice > 0 ? fmt(lensTypePrice) : 'Free';
    }
    var lensContainer = document.getElementById('summary-lens-container');
    if (lensContainer) {
      lensContainer.style.display = this.state.lensType ? '' : 'none';
    }

    var sunPrice = this.state.sunglassesPrice || 0;
    var sunPriceEl = document.getElementById('summary-lens-color-price');
    if (sunPriceEl) {
      sunPriceEl.textContent = sunPrice > 0 ? fmt(sunPrice) : '';
    }

    var addonTotal = 0;
    var addons = this.state.addons || [];
    addons.forEach(function (addonKey) {
      var addonVariantId = Config.ADDON_VARIANTS && Config.ADDON_VARIANTS[addonKey];
      var addonPrice = getVariantPrice(addonVariantId);
      if (addonPrice != null) {
        addonTotal += addonPrice;
      }
    });
    var addonPriceEl = document.getElementById('summary-lens-addons-price');
    if (addonPriceEl) {
      addonPriceEl.textContent = addonTotal > 0 ? fmt(addonTotal) : 'Free';
    }

    var subtotalEl = document.getElementById('summary-subtotal');
    if (subtotalEl) {
      var total = this.calculateTotalPrice();
      if (Currency && typeof Currency.formatMoney === 'function') {
        subtotalEl.textContent = Currency.formatMoney(total);
      } else {
        var currencyCode =
          Currency && typeof Currency.getActiveCurrency === 'function' ? Currency.getActiveCurrency() : 'USD';
        subtotalEl.textContent = '$' + total.toFixed(2) + ' ' + currencyCode;
      }
    }

    var commentsEl = document.getElementById('comments');
    var summaryCommentsContainer = document.getElementById('summary-comments-container');
    var summaryCommentsText = document.getElementById('summary-comments-text');
    if (commentsEl && summaryCommentsContainer && summaryCommentsText) {
      var comments = commentsEl.value.trim();
      if (comments) {
        summaryCommentsContainer.style.display = '';
        summaryCommentsText.textContent = comments;
      } else {
        summaryCommentsContainer.style.display = 'none';
      }
    }

    var readingEl = document.getElementById('summary-magnifier-strength');
    var readingForSummary = this.state.reading || {};
    var summaryReadingStrength = readingForSummary.strength || readingForSummary.reading_strength;
    if (readingEl && summaryReadingStrength) {
      readingEl.style.display = 'block';
      readingEl.textContent = 'Reading Strength: ' + summaryReadingStrength;
    }
  };

  /* ─── CART SUBMISSION ─── */

  LensSelectorApp.prototype.initCartSubmission = function () {
    var self = this;
    var saveBtn = this.elements.saveButton;
    if (!saveBtn) return;

    saveBtn.addEventListener('click', function () {
      self.submitToCart();
    });
  };

  LensSelectorApp.prototype.submitToCart = function () {
    var self = this;
    var CartSubmission = window.OletLens.CartSubmission;
    if (!CartSubmission) return;
    var saveBtn = this.elements.saveButton;
    var originalSaveBtnText = saveBtn ? saveBtn.textContent : '';
    if (saveBtn && saveBtn.dataset.submitting === 'true') return;

    // If a prescription file was selected but the upload to the backend is still in progress,
    // block submission so we do not lose the file URL in the cart bundle.
    if (this.uploadedPrescriptionFileBase64 && this.rxUploadInProgress) {
      showToast('Please wait while your prescription file finishes uploading.', 'error');
      return;
    }

    if (saveBtn) {
      saveBtn.dataset.submitting = 'true';
      saveBtn.setAttribute('disabled', 'disabled');
      saveBtn.setAttribute('aria-busy', 'true');
      saveBtn.textContent = 'Updating Cart...';
    }

    var spinner = document.getElementById('lens-loading-spinner');
    var loadingText = document.getElementById('lens-loading-text');
    if (spinner) spinner.style.display = 'block';
    if (loadingText) loadingText.style.display = 'none';

    var frameVariantId = CartSubmission.getFrameVariantId();
    if (!frameVariantId) {
      showToast('Could not detect frame variant. Please refresh and try again.', 'error');
      if (spinner) spinner.style.display = 'none';
      if (loadingText) loadingText.style.display = 'block';
      if (saveBtn) {
        saveBtn.dataset.submitting = 'false';
        saveBtn.removeAttribute('disabled');
        saveBtn.setAttribute('aria-busy', 'false');
        saveBtn.textContent = originalSaveBtnText;
      }
      return;
    }

    var totalPrice = this.calculateTotalPrice();
    var customerIdForOrder = this.getCustomerId();
    var saveOrderPromise = customerIdForOrder
      ? self.saveLensOrder(totalPrice, frameVariantId, customerIdForOrder).catch(function (eOrder) {
          try {
            if (typeof console !== 'undefined') {
              console.error('[LensOrders] Failed to save lens order before cart add:', eOrder);
            }
          } catch (eLog) {}
          // showToast(
          //   'Your prescription could not be saved for next time, but your cart will still be updated.',
          //   'error',
          // );
        })
      : Promise.resolve();

    saveOrderPromise
      .then(function () {
        return CartSubmission.removePreviousBundle(frameVariantId, self.state.editBundleKey || null);
      })
      .then(function () {
        self.stripIncompatibleLensAddons();
        var payload = CartSubmission.buildCartPayload(self.state, frameVariantId, Config);
        return CartSubmission.addBundleToCart(payload);
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        showToast('Error adding to cart: ' + (err.message || err), 'error');
        if (spinner) spinner.style.display = 'none';
        if (loadingText) loadingText.style.display = 'block';
        if (saveBtn) {
          saveBtn.dataset.submitting = 'false';
          saveBtn.removeAttribute('disabled');
          saveBtn.setAttribute('aria-busy', 'false');
          saveBtn.textContent = originalSaveBtnText;
        }
      });
  };

  /* ─── LOAD PREVIOUS PRESCRIPTION ─── */

  LensSelectorApp.prototype.getCustomerId = function () {
    var el = this.elements.productPrice;
    if (!el) return null;
    var id = el.getAttribute('customer-id');
    return id || null;
  };

  LensSelectorApp.prototype.buildLensOrderPayload = function (totalPrice, frameVariantId) {
    var usageType = this.state.usage || 'single_vision';
    var lensPackage = this.state.lensType || 'basic';
    var lensVid = this.state.lensVariantId != null ? Number(this.state.lensVariantId) : null;
    var disallowed =
      typeof Utils.getDisallowedAddonKeys === 'function'
        ? Utils.getDisallowedAddonKeys(usageType, lensPackage, lensVid)
        : [];

    var payload = {
      shopify_customer_id: this.getCustomerId() || '',
      type: usageType,
      package: lensPackage,
      price: typeof totalPrice === 'number' ? totalPrice : 0,
    };

    if (usageType === 'reading') {
      var rd = this.state.reading || {};
      var rdStrength = rd.strength != null && rd.strength !== '' ? rd.strength : rd.reading_strength;
      payload.reading = {
        strength: rdStrength != null && rdStrength !== '' ? rdStrength : null,
        pd: rd.pd || {},
      };
    } else if (usageType === 'non-prescription') {
      payload.prescription = {
        non_prescription: true,
      };
    } else {
      var isUpload = this.isPrescriptionUploadFlow();
      var rx = this.state.prescription || {};

      if (isUpload) {
        payload.rx_method = 'upload';
        payload.prescription = {
          person_name: rx.person_name || '',
          comments: rx.comments || '',
          pd: rx.pd || {},
        };
      } else {
        payload.rx_method = 'manual';
        var prism = rx.prism || {};
        var odPrism = prism.od || {};
        var osPrism = prism.os || {};
        var hasPrism = !!rx.hasPrism;

        payload.prescription = {
          od: {
            sph: rx.od && rx.od.sph != null ? rx.od.sph : 0,
            cyl: rx.od && rx.od.cyl != null ? rx.od.cyl : 0,
            axis: rx.od && rx.od.axis != null ? rx.od.axis : 0,
            add: rx.od && rx.od.add != null ? rx.od.add : null,
            prism: {
              has_prism: hasPrism,
              vertical: odPrism.vertical != null && odPrism.vertical !== 'n/a' ? Number(odPrism.vertical) : null,
              horizontal: odPrism.horizontal != null && odPrism.horizontal !== 'n/a' ? Number(odPrism.horizontal) : null,
              base_direction: odPrism.vertical_dir && odPrism.vertical_dir !== 'n/a' ? odPrism.vertical_dir : null,
              other_base_direction:
                odPrism.horizontal_dir && odPrism.horizontal_dir !== 'n/a' ? odPrism.horizontal_dir : null,
            },
          },
          os: {
            sph: rx.os && rx.os.sph != null ? rx.os.sph : 0,
            cyl: rx.os && rx.os.cyl != null ? rx.os.cyl : 0,
            axis: rx.os && rx.os.axis != null ? rx.os.axis : 0,
            add: rx.os && rx.os.add != null ? rx.os.add : null,
            prism: {
              has_prism: hasPrism,
              vertical: osPrism.vertical != null && osPrism.vertical !== 'n/a' ? Number(osPrism.vertical) : null,
              horizontal: osPrism.horizontal != null && osPrism.horizontal !== 'n/a' ? Number(osPrism.horizontal) : null,
              base_direction: osPrism.vertical_dir && osPrism.vertical_dir !== 'n/a' ? osPrism.vertical_dir : null,
              other_base_direction:
                osPrism.horizontal_dir && osPrism.horizontal_dir !== 'n/a' ? osPrism.horizontal_dir : null,
            },
          },
          pd: rx.pd || {},
          comments: rx.comments || '',
          person_name: rx.person_name || '',
        };
      }
    }

    if (this.state.sunglasses) {
      var sunKeyOrder = Utils.normalizeSunglassesAddonKey
        ? Utils.normalizeSunglassesAddonKey(this.state.sunglasses)
        : this.state.sunglasses;
      if (disallowed.indexOf(sunKeyOrder) === -1) {
        payload.sunglasses_upgrade = {
          type: this.state.sunglasses,
          color: this.state.sunglassesColor || null,
        };
      }
    }

    if (Array.isArray(this.state.addons) && this.state.addons.length) {
      var addonsForOrder = this.state.addons.filter(function (k) {
        var nk = Utils.normalizeSunglassesAddonKey ? Utils.normalizeSunglassesAddonKey(k) : k;
        return disallowed.indexOf(nk) === -1;
      });
      if (addonsForOrder.length) {
        payload.addons = addonsForOrder;
      }
    }

    if (this.state.rxMethod === 'upload' && payload.prescription) {
      var existingFileUrl = this.state.rxFileUrl && String(this.state.rxFileUrl).trim();
      var resolvedFileType =
        this.uploadedPrescriptionFileType || (existingFileUrl && /\.pdf(\?|$)/i.test(existingFileUrl) ? 'pdf' : 'image');

      if (existingFileUrl) {
        payload.prescription.prescription_image_url = existingFileUrl;
        payload.prescription.prescription_file_type = resolvedFileType;
      } else if (this.uploadedPrescriptionFileBase64) {
        payload.prescription_image = this.uploadedPrescriptionFileBase64;
        payload.prescription.prescription_file_type = resolvedFileType;
      }
    }

    if (frameVariantId) {
      payload.variant_id = frameVariantId;
    }

    return payload;
  };

  LensSelectorApp.prototype.saveLensOrder = function (totalPrice, frameVariantId, customerId) {
    var baseUrl = (Config && Config.API_BASE_URL) || '';
    if (!baseUrl || !customerId) {
      return Promise.resolve(null);
    }

    var body = this.buildLensOrderPayload(totalPrice, frameVariantId);

    return fetch(baseUrl + '/api/lens-orders', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
      keepalive: true,
    }).then(function (response) {
      if (!response.ok) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (json) {
            var message = (json && json.message) || 'Lens order save failed: ' + response.status;
            throw new Error(message);
          });
      }
      return response.json();
    });
  };

  LensSelectorApp.prototype.initPreviousRxLoader = function () {
    var btn = this.elements.loadPreviousOrderBtn;
    if (!btn) return;
    var self = this;
    btn.addEventListener('click', function () {
      self.handleLoadPreviousRx(btn);
    });
  };

  LensSelectorApp.prototype.handleLoadPreviousRx = function (btn) {
    var CartSubmission = window.OletLens && window.OletLens.CartSubmission;
    if (!CartSubmission || typeof CartSubmission.loadPreviousRx !== 'function') {
      showToast('Previous prescriptions are not available right now.', 'error');
      return;
    }

    var customerId = this.getCustomerId();
    if (!customerId) {
      showToast('Please log in to load your previous prescription.', 'error');
      return;
    }

    var self = this;
    var originalHtml = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML =
      '<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span> Loading...';

    var spinner = document.getElementById('lens-loading-spinner');
    var loadingText = document.getElementById('lens-loading-text');
    if (spinner) spinner.style.display = 'block';
    if (loadingText) loadingText.style.display = 'none';

    CartSubmission.loadPreviousRx(customerId)
      .then(function (data) {
        if (!data || !data.order_data || !data.order_data.prescription) {
          showToast('No previous prescriptions found.', 'error');
          return;
        }
        self.applyPreviousRxToForm(data.order_data);
        showToast('Previous prescription loaded.', 'success');
      })
      .catch(function (err) {
        showToast('Failed to load previous prescription: ' + (err && err.message ? err.message : err), 'error');
      })
      .finally(function () {
        btn.disabled = false;
        btn.innerHTML = originalHtml;
        if (spinner) spinner.style.display = 'none';
        if (loadingText) loadingText.style.display = 'block';
      });
  };

  LensSelectorApp.prototype.syncPrescriptionUi = function (rxMethod) {
    var method = rxMethod || 'manual';
    var prescriptionFormContainer = document.getElementById('prescription-form-container');
    var uploadContainer = document.getElementById('prescription-image-upload-container');
    var toggleBtn = document.getElementById('add-manual-prescription-button');
    var uploadTitle = document.getElementById('prescription-image-upload-title');

    if (!prescriptionFormContainer || !uploadContainer) return;

    if (method === 'upload') {
      uploadContainer.classList.remove('hide-prescription');
      prescriptionFormContainer.classList.remove('show-prescription');
      prescriptionFormContainer.classList.add('hide-prescription');

      if (toggleBtn) {
        toggleBtn.textContent = 'Or Type your prescription';
      }
      if (uploadTitle) {
        uploadTitle.textContent = 'Upload Prescription File';
      }
    } else {
      prescriptionFormContainer.classList.remove('hide-prescription');
      prescriptionFormContainer.classList.add('show-prescription');
      uploadContainer.classList.add('hide-prescription');

      if (toggleBtn) {
        toggleBtn.textContent = 'Or Upload Prescription File';
      }
      if (uploadTitle) {
        uploadTitle.textContent = 'Type your prescription';
      }
    }

    this.setState('rxMethod', method);
  };

  LensSelectorApp.prototype.restorePrescriptionUploadPreview = function (url, fileType) {
    if (!url) return;

    var fileUrl = String(url).trim();
    if (!fileUrl) return;

    var isPdf = fileType === 'pdf' || /\.pdf(\?|$)/i.test(fileUrl);
    var dropzone = document.getElementById('prescriptionDropzone');
    var previewContainer = document.getElementById('previewContainer');
    var preview = document.getElementById('prescriptionPreview');
    var pdfPreview = document.getElementById('pdfPreview');
    var pdfFileName = document.getElementById('pdfFileName');

    this.uploadedPrescriptionFile = null;
    this.uploadedPrescriptionFileBase64 = null;
    this.uploadedPrescriptionFileName = isPdf ? 'Prescription.pdf' : 'Prescription image';
    this.uploadedPrescriptionFileType = isPdf ? 'pdf' : 'image';
    this.uploadedPrescriptionFileUrl = null;

    this.setState('rxFileUrl', fileUrl);
    this.setState('rxFilePreview', fileUrl);
    this.setState('rxMethod', 'upload');

    if (!previewContainer) return;

    previewContainer.classList.remove('hidden');
    if (dropzone) dropzone.classList.add('hidden');

    if (isPdf) {
      if (preview) {
        preview.removeAttribute('src');
        preview.classList.add('hidden');
      }
      if (pdfPreview) pdfPreview.classList.remove('hidden');
      if (pdfFileName) pdfFileName.textContent = this.uploadedPrescriptionFileName;
    } else {
      if (pdfPreview) pdfPreview.classList.add('hidden');
      if (preview) {
        preview.classList.remove('hidden');
        preview.src = fileUrl;
      }
    }
  };

  LensSelectorApp.prototype.applyPreviousRxToForm = function (orderData) {
    if (!orderData || !orderData.prescription) return;
    var src = orderData.prescription || {};
    var imageUrl = src.prescription_image_url ? String(src.prescription_image_url).trim() : '';
    var fileType = src.prescription_file_type || '';
    var hasUpload = !!imageUrl;

    if (hasUpload) {
      var uploadRx = {
        person_name: src.person_name || '',
        comments: src.comments || '',
        pd: null,
      };

      if (src.pd) {
        if (src.pd.combined != null && src.pd.combined !== '') {
          uploadRx.pd = { combined: src.pd.combined };
        } else if (src.pd.left != null || src.pd.right != null) {
          uploadRx.pd = {
            left: src.pd.left,
            right: src.pd.right,
          };
        }
      }

      this.setState('prescription', uploadRx);

      var uploadNameInput = document.getElementById('person_name');
      if (uploadNameInput) uploadNameInput.value = uploadRx.person_name;
      var uploadCommentsInput = document.getElementById('comments');
      if (uploadCommentsInput) uploadCommentsInput.value = uploadRx.comments;
      if (uploadRx.pd) {
        this.prefillPrescriptionForm({ pd: uploadRx.pd });
      }

      this.restorePrescriptionUploadPreview(imageUrl, fileType);
      this.syncPrescriptionUi('upload');

      var UploadPrescriptionModule = window.OletLens && window.OletLens.PrescriptionModule;
      if (UploadPrescriptionModule && typeof UploadPrescriptionModule.updateRecommendation === 'function') {
        UploadPrescriptionModule.updateRecommendation();
      }

      this.calculateTotalPrice();
      return;
    }

    var rx = {
      person_name: src.person_name || '',
      comments: src.comments || '',
      od: {
        sph: parseFloat((src.od && src.od.sph) || 0) || 0,
        cyl: parseFloat((src.od && src.od.cyl) || 0) || 0,
        axis: src.od && src.od.axis != null ? src.od.axis : '',
        add: src.od && src.od.add != null ? src.od.add : 'n/a',
      },
      os: {
        sph: parseFloat((src.os && src.os.sph) || 0) || 0,
        cyl: parseFloat((src.os && src.os.cyl) || 0) || 0,
        axis: src.os && src.os.axis != null ? src.os.axis : '',
        add: src.os && src.os.add != null ? src.os.add : 'n/a',
      },
      pd: null,
      hasPrism: false,
      prism: null,
    };

    if (src.pd) {
      if (src.pd.combined != null && src.pd.combined !== '') {
        rx.pd = { combined: src.pd.combined };
      } else if (src.pd.left != null || src.pd.right != null) {
        rx.pd = {
          left: src.pd.left,
          right: src.pd.right,
        };
      }
    }

    var odPrism = src.od && src.od.prism;
    var osPrism = src.os && src.os.prism;
    var hasPrismFlag = (odPrism && odPrism.has_prism) || (osPrism && osPrism.has_prism);
    if (hasPrismFlag) {
      rx.hasPrism = true;
      rx.prism = {
        od: {
          vertical: odPrism && odPrism.vertical != null ? odPrism.vertical : 'n/a',
          vertical_dir: odPrism && odPrism.base_direction ? odPrism.base_direction : 'n/a',
          horizontal: odPrism && odPrism.horizontal != null ? odPrism.horizontal : 'n/a',
          horizontal_dir: odPrism && odPrism.other_base_direction ? odPrism.other_base_direction : 'n/a',
        },
        os: {
          vertical: osPrism && osPrism.vertical != null ? osPrism.vertical : 'n/a',
          vertical_dir: osPrism && osPrism.base_direction ? osPrism.base_direction : 'n/a',
          horizontal: osPrism && osPrism.horizontal != null ? osPrism.horizontal : 'n/a',
          horizontal_dir: osPrism && osPrism.other_base_direction ? osPrism.other_base_direction : 'n/a',
        },
      };
    } else {
      rx.hasPrism = false;
      rx.prism = null;
    }

    this.setState('prescription', rx);
    this.prefillPrescriptionForm(rx);
    this.syncPrescriptionUi('manual');

    var PrescriptionModule = window.OletLens && window.OletLens.PrescriptionModule;
    if (PrescriptionModule && typeof PrescriptionModule.updateRecommendation === 'function') {
      PrescriptionModule.updateRecommendation();
    }

    this.calculateTotalPrice();
  };

  /* ─── SUNGLASSES PRICE SYNC ─── */

  LensSelectorApp.prototype.initSunglassesPriceSync = function () {
    var self = this;
    this.onStateChange(function (state) {
      if (state.sunglasses) {
        var addonVariantId = Config.ADDON_VARIANTS && Config.ADDON_VARIANTS[state.sunglasses];
        var price = getVariantPrice(addonVariantId);
        var resolved = price != null ? price : 0;
        if (self.state.sunglassesPrice === resolved) return;
        self.state.sunglassesPrice = resolved;
      } else {
        if (self.state.sunglassesPrice === 0) return;
        self.state.sunglassesPrice = 0;
      }
      self.calculateTotalPrice();
    });
  };

  LensSelectorApp.prototype.updateAddonAndSunglassesPriceLabels = function () {
    var Currency = window.OletLens && window.OletLens.Currency;
    if (!Currency || typeof Currency.formatMoney !== 'function') return;

    var sunEls = document.querySelectorAll('.sunglasses-upgrade');
    sunEls.forEach(function (el) {
      var priceEl = el.querySelector('.sunglasses-price');
      if (!priceEl) return;
      var type = normalizeSunglassesType(el.getAttribute('sunglasses-type'));
      var addonVariantId = Config.ADDON_VARIANTS && Config.ADDON_VARIANTS[type];
      var price = getVariantPrice(addonVariantId);
      priceEl.textContent = price && price > 0 ? Currency.formatMoney(price) : 'Free';
    });

    var addonEls = document.querySelectorAll('.lens-addon');
    addonEls.forEach(function (el) {
      var priceEl = el.querySelector('.lense-type-price');
      if (!priceEl) return;
      var key = el.getAttribute('lens-addon');
      var addonVariantId = Config.ADDON_VARIANTS && Config.ADDON_VARIANTS[key];
      var price = getVariantPrice(addonVariantId);
      priceEl.textContent = price && price > 0 ? Currency.formatMoney(price) : 'Free';
    });
  };

  /* ─── INIT ─── */

  LensSelectorApp.prototype.init = function () {
    var self = this;

    if (this.elements.nextButton) {
      this.elements.nextButton.addEventListener('click', function () {
        self.navigateNext();
      });
    }
    if (this.elements.prevButton) {
      this.elements.prevButton.addEventListener('click', function () {
        self.navigatePrev();
      });
    }

    this.initUsageHandlers();
    this.initCartSubmission();
    this.initPreviousRxLoader();

    if (window.OletLens.PrescriptionModule && typeof window.OletLens.PrescriptionModule.init === 'function') {
      window.OletLens.PrescriptionModule.init(this);
    }
    if (window.OletLens.ReadingModule && typeof window.OletLens.ReadingModule.init === 'function') {
      window.OletLens.ReadingModule.init(this);
    }
    if (window.OletLens.AddonsModule && typeof window.OletLens.AddonsModule.init === 'function') {
      window.OletLens.AddonsModule.init(this);
    }
    if (window.OletLens.SunglassesModule && typeof window.OletLens.SunglassesModule.init === 'function') {
      window.OletLens.SunglassesModule.init(this);
    }

    this.initSunglassesPriceSync();

    this.updateAddonAndSunglassesPriceLabels();

    if (
      window.OletLens &&
      window.OletLens.Currency &&
      typeof window.OletLens.Currency.onCurrencyChange === 'function'
    ) {
      window.OletLens.Currency.onCurrencyChange(function () {
        if (self.state.lensType) {
          self.renderLensOptions();
        }
        self.calculateTotalPrice();
        if (self.currentStep === (Config.STEPS && Config.STEPS.SUMMARY)) {
          self.updateSummaryPrices();
        }
        self.updateAddonAndSunglassesPriceLabels();
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event.data && event.data.variant;
        if (!variant || variant.id == null) return;
        self.basePrice = getFrameBasePrice(self.elements.productPrice, variant.id);
        if (self.elements.productPrice) {
          self.elements.productPrice.setAttribute('product-price-cents', String(variant.price || 0));
        }
        self.calculateTotalPrice();
      });
    }

    this.renderStep();
    this.calculateTotalPrice();

    this.initMoreOptionsToggle();
    this.restoreEditSession();
    this.syncRxMethodWithPrescriptionUi();
  };

  LensSelectorApp.prototype.initMoreOptionsToggle = function () {
    var btn = document.querySelector('.btn-show-more-rx');
    var container = document.querySelector('.prism-container');
    if (!btn || !container) return;

    btn.addEventListener('click', function () {
      if (container.classList.contains('show-less')) {
        container.classList.remove('show-less');
        container.classList.add('show-more');
        btn.querySelector('span:first-child').textContent = 'Less options';
      } else {
        container.classList.remove('show-more');
        container.classList.add('show-less');
        btn.querySelector('span:first-child').textContent = 'More options';
      }
    });
  };

  /* ─── RESTORE EDIT SESSION ─── */

  LensSelectorApp.prototype.restoreEditSession = function () {
    var raw;
    try {
      raw = sessionStorage.getItem('olet_edit_bundle');
      sessionStorage.removeItem('olet_edit_bundle');
    } catch (e) {
      return;
    }

    if (!raw) return;

    var data;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!data || !data.usage) return;

    this.setState('editBundleKey', data.bundleKey && String(data.bundleKey).trim() ? String(data.bundleKey).trim() : null);
    this.setState('lensVariantId', data.lensVariantId ? parseInt(data.lensVariantId, 10) || null : null);

    var self = this;
    var S = Config.STEPS;

    var lensContainer = document.getElementById('lens-container');
    if (lensContainer) {
      lensContainer.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }

    var usage = data.usage;
    this.setState('usage', usage);

    // Lock lens type from the cart's saved variant BEFORE rendering lens options.
    // Otherwise the "recommended" auto-selection can pick the wrong tier during prefill.
    if (!this.state.lensType && data.lensVariantId) {
      var parsedTargetVariantId = parseInt(data.lensVariantId, 10);
      if (!Number.isNaN(parsedTargetVariantId)) {
        var optionsData = Config.LENS_OPTIONS_DATA || {};
        var usageOptions = optionsData[usage] || [];
        var baseVariants = Config.LENS_BASE_VARIANTS || {};
        var usageVariants = baseVariants[usage] || {};
        for (var i = 0; i < usageOptions.length; i++) {
          var opt = usageOptions[i];
          if (usageVariants && usageVariants[opt.type] === parsedTargetVariantId) {
            var variantPrice = getVariantPrice(parsedTargetVariantId);
            this.setState('lensType', opt.type);
            this.setState('lensVariantId', parsedTargetVariantId);
            this.setState('lensTypePrice', variantPrice != null ? variantPrice : opt.price || 0);
            break;
          }
        }
      }
    }

    var mainUsageEls = document.querySelectorAll('#main-options .lens-usage');
    mainUsageEls.forEach(function (el) {
      el.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
    });

    var isPrescriptionSub = usage === 'single_vision' || usage === 'progressives' || usage === 'bifocals';

    if (isPrescriptionSub) {
      var prescriptionCard = document.querySelector('#main-options .lens-usage[usage-type="prescription"]');
      if (prescriptionCard) prescriptionCard.classList.add('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');

      var typeEls = document.querySelectorAll('#prescription-type-selection .lens-usage');
      typeEls.forEach(function (el) {
        el.classList.remove('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
        if (el.getAttribute('usage-type') === usage) {
          el.classList.add('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
        }
      });

      this.updateAddValuesVisibility(usage);
      document.dispatchEvent(new CustomEvent('lens-type-changed', { detail: { usageType: usage } }));
    } else {
      var usageCard = document.querySelector('#main-options .lens-usage[usage-type="' + usage + '"]');
      if (usageCard) usageCard.classList.add('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
    }

    if (data.rxJson) {
      try {
        var jsonStr = data.rxJson;
        if (typeof jsonStr === 'string' && jsonStr.indexOf('&quot;') !== -1) {
          var textarea = document.createElement('textarea');
          textarea.innerHTML = jsonStr;
          jsonStr = textarea.value;
        }
        var rx = JSON.parse(jsonStr);
        if (usage === 'reading') {
          var ReadingModule = window.OletLens.ReadingModule;
          var strengthRaw =
            rx.strength != null && rx.strength !== '' ? rx.strength : rx.reading_strength;
          var normalizedStrength =
            strengthRaw != null && String(strengthRaw).trim() !== '' ? String(strengthRaw).trim() : null;
          var readingState = {
            person_name: rx.person_name || '',
            strength: normalizedStrength,
            pd: rx.pd || {},
          };
          this.setState('reading', readingState);

          var personNameReading = document.getElementById('person_name_reading');
          if (personNameReading && readingState.person_name) {
            personNameReading.value = readingState.person_name;
          }

          if (normalizedStrength && ReadingModule && ReadingModule.handleMagnificationSelection) {
            ReadingModule.handleMagnificationSelection(normalizedStrength);
          }

          if (rx.pd) {
            var hasDualPd = !!(rx.pd.left || rx.pd.right);
            if (hasDualPd) {
              var readingPdCheckbox = document.getElementById('noSamePdReading');
              if (readingPdCheckbox) {
                readingPdCheckbox.checked = true;
                if (ReadingModule && ReadingModule.handleReadingPDToggle) {
                  ReadingModule.handleReadingPDToggle(true);
                }
              }
              var odPdReading = document.getElementById('od_pd_reading');
              var osPdReading = document.getElementById('os_pd_reading');
              if (odPdReading && rx.pd.left != null && rx.pd.left !== '') {
                odPdReading.value = String(rx.pd.left);
              }
              if (osPdReading && rx.pd.right != null && rx.pd.right !== '') {
                osPdReading.value = String(rx.pd.right);
              }
            } else if (rx.pd.combined != null && rx.pd.combined !== '') {
              var readingPdSingle =
                document.querySelector('#step-2\\.5 #pd_reading') || document.getElementById('pd_reading');
              if (readingPdSingle) {
                readingPdSingle.value = String(rx.pd.combined);
              }
              var readingPdCheckboxOff = document.getElementById('noSamePdReading');
              if (readingPdCheckboxOff && readingPdCheckboxOff.checked) {
                readingPdCheckboxOff.checked = false;
                if (ReadingModule && ReadingModule.handleReadingPDToggle) {
                  ReadingModule.handleReadingPDToggle(false);
                }
              }
            }
          }
        } else if (usage !== 'non-prescription' && (rx.od || rx.os)) {
          this.setState('prescription', rx);
          this.prefillPrescriptionForm(rx);
        }
      } catch (e) {
        /* ignore */
      }
    }

    if (data.rxMethod === 'upload' && data.rxFileUrl) {
      this.setState('rxFileUrl', data.rxFileUrl);
      this.restorePrescriptionUploadPreview(data.rxFileUrl, data.rxFileType || '');
    }

    this.syncPrescriptionUi(data.rxMethod || 'manual');

    if (data.sunglasses) {
      var sunglassesType = normalizeSunglassesType(data.sunglasses);
      this.setState('sunglasses', sunglassesType);
      this.setState('sunglassesColor', data.sunglassesColor || null);

      var sunEl = document.querySelector(
        '.sunglasses-upgrade[sunglasses-type="' + sunglassesType + '"], .sunglasses-upgrade[sunglasses-type="' + data.sunglasses + '"]',
      );
      if (sunEl) {
        sunEl.classList.add('active', 'border-[#009AD6]', 'bg-[#E6F7FF]');
        this.setState('sunglassesPrice', parseFloat(sunEl.getAttribute('option-price')) || 0);

        if (data.sunglassesColor) {
          var colorEl = sunEl.querySelector('.color-select[data-color="' + data.sunglassesColor + '"]');
          if (colorEl) colorEl.classList.add('selected-color');
        }
      }
    }

    if (data.addons) {
      var addonKeys = data.addons.split(',').filter(function (k) {
        return k.trim();
      });
      this.setState('addons', addonKeys);

      addonKeys.forEach(function (key) {
        var addonEl = document.querySelector('.lens-addon[lens-addon="' + key.trim() + '"]');
        if (addonEl) addonEl.classList.add('active', '!border-[#009AD6]', '!bg-[#E6F7FF]');
      });
    }

    this.renderLensOptions();

    if (!this.state.lensType && (data.lensVariantId || data.lensTitle)) {
      var self2 = this;
      setTimeout(function () {
        var lensCards = document.querySelectorAll('#lens-selection .lens-type');
        var optionsData = Config.LENS_OPTIONS_DATA || {};
        var options = optionsData[usage] || [];
        var baseVariants = Config.LENS_BASE_VARIANTS || {};
        var usageVariants = baseVariants[usage] || {};
        var matchFound = false;

        if (data.lensVariantId) {
          var targetVariantId = parseInt(data.lensVariantId, 10);
          options.forEach(function (opt, idx) {
            if (matchFound) return;
            var variantId = usageVariants[opt.type];
            if (variantId === targetVariantId && lensCards[idx]) {
              self2.handleLensTypeSelection(lensCards[idx], opt);
              matchFound = true;
            }
          });
        }

        if (!matchFound && data.lensTitle) {
          var searchTitle = data.lensTitle.toLowerCase();
          options.forEach(function (opt, idx) {
            if (matchFound) return;
            if (
              searchTitle.indexOf(opt.type) !== -1 ||
              searchTitle.indexOf(opt.name.toLowerCase()) !== -1 ||
              opt.name.toLowerCase().indexOf(searchTitle.split('–')[0].trim()) !== -1
            ) {
              if (lensCards[idx]) {
                self2.handleLensTypeSelection(lensCards[idx], opt);
                matchFound = true;
              }
            }
          });
        }
      }, 100);
    }

    this.setState('editMode', true);

    var saveBtn = this.elements.saveButton;
    if (saveBtn) {
      saveBtn.textContent = 'Update Cart';
    }

    this.currentStep = S.SUMMARY;
    this.renderSummary();
    this.renderStep();
    this.stripIncompatibleLensAddons();
    this.calculateTotalPrice();
  };

  LensSelectorApp.prototype.prefillPrescriptionForm = function (rx) {
    if (!rx) return;

    function setVal(id, val) {
      var el = document.getElementById(id);
      if (el && val != null && val !== 'n/a') el.value = String(val);
    }

    if (rx.person_name) setVal('person_name', rx.person_name);
    if (rx.comments) setVal('comments', rx.comments);

    if (rx.od) {
      setVal('od_sph', Number(rx.od.sph || 0).toFixed(2));
      setVal('od_cyl', Number(rx.od.cyl || 0).toFixed(2));
      if (rx.od.axis) setVal('od_axis', rx.od.axis);
      if (rx.od.add && rx.od.add !== 'n/a') setVal('od_add', rx.od.add);
    }
    if (rx.os) {
      setVal('os_sph', Number(rx.os.sph || 0).toFixed(2));
      setVal('os_cyl', Number(rx.os.cyl || 0).toFixed(2));
      if (rx.os.axis) setVal('os_axis', rx.os.axis);
      if (rx.os.add && rx.os.add !== 'n/a') setVal('os_add', rx.os.add);
    }

    if (rx.pd) {
      if (rx.pd.combined) {
        setVal('pd', rx.pd.combined);
      } else if (rx.pd.left || rx.pd.right) {
        var pdCheckbox = document.getElementById('noSamePd');
        if (pdCheckbox) {
          pdCheckbox.checked = true;
          var PrescriptionModule = window.OletLens.PrescriptionModule;
          if (PrescriptionModule && PrescriptionModule.handlePDToggle) {
            PrescriptionModule.handlePDToggle(true);
          }
        }
        setVal('od_pd', rx.pd.left || rx.pd.right);
        setVal('os_pd', rx.pd.right || rx.pd.left);
      }
    }

    if (rx.hasPrism && rx.prism) {
      var prismCheckbox = document.getElementById('prism');
      if (prismCheckbox) {
        prismCheckbox.checked = true;
        var PrescriptionModule2 = window.OletLens.PrescriptionModule;
        if (PrescriptionModule2 && PrescriptionModule2.handlePrismToggle) {
          PrescriptionModule2.handlePrismToggle(true);
        }
      }
      var moreBtn = document.querySelector('.btn-show-more-rx');
      var prismContainer = document.querySelector('.prism-container');
      if (moreBtn && prismContainer && prismContainer.classList.contains('show-less')) {
        prismContainer.classList.remove('show-less');
        prismContainer.classList.add('show-more');
        var spanEl = moreBtn.querySelector('span:first-child');
        if (spanEl) spanEl.textContent = 'Less options';
      }

      if (rx.prism.od) {
        setVal('od_prismnum_v', rx.prism.od.vertical);
        setVal('od_prismdir_v', rx.prism.od.vertical_dir);
        setVal('od_prismnum_h', rx.prism.od.horizontal);
        setVal('od_prismdir_h', rx.prism.od.horizontal_dir);
      }
      if (rx.prism.os) {
        setVal('os_prismnum_v', rx.prism.os.vertical);
        setVal('os_prismdir_v', rx.prism.os.vertical_dir);
        setVal('os_prismnum_h', rx.prism.os.horizontal);
        setVal('os_prismdir_h', rx.prism.os.horizontal_dir);
      }
    }

    var prescriptionFormContainer = document.getElementById('prescription-form-container');
    if (prescriptionFormContainer && prescriptionFormContainer.classList.contains('hide-prescription')) {
      prescriptionFormContainer.classList.remove('hide-prescription');
      prescriptionFormContainer.classList.add('show-prescription');
    }

    var PrescriptionModule3 = window.OletLens.PrescriptionModule;
    if (PrescriptionModule3 && PrescriptionModule3.handleCylAxisDependency) {
      PrescriptionModule3.handleCylAxisDependency();
    }
  };

  /* ─── BOOTSTRAP ─── */

  function bootstrap() {
    if (!document.getElementById('lens-container')) {
      return;
    }
    var app = new LensSelectorApp();
    app.init();
    window.OletLens.App = app;
    window.lensSelectorApp = app;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
